module.exports = __webpack_public_path__ + "img/Property 1=4x3, Property 2=BW - Botswana.83486d8a.svg";